import { useSelector } from 'react-redux';

export const useLocale = () =>
    useSelector(
        (state) =>
            state.user?.activeBusiness?.businessSettings?.locale || 'en-US'
    );
